import axios, {AxiosError} from "axios"; 
import { bindEvent } from "./_helpers";
// @ts-ignore
import Modal from "./modal.ts";


export default class SupportModal extends Modal {
    async init (): Promise<void> {
        await this.wrapLabels();
        bindEvent('#wpcf7-f496-o1', 'submit', this.createQuestionOnSubmit.bind(this));

        super.init();
    }

    protected async wrapLabels(): Promise<void> {
        const labels = this.modal.querySelectorAll('.input-label');
        labels.forEach((label) => {
            const wrapper = label.parentElement.querySelector('.wpcf7-form-control-wrap') as HTMLElement;
            wrapper.appendChild(label);
        });
    }

    protected async createQuestionOnSubmit(event: Event): Promise<void> {
        const form = event.target as HTMLFormElement;
        const formData: FormData = new FormData(form);
        formData.append('action', 'create_question');

        try {
            const response = await axios.post(wc_add_to_cart_params.ajax_url, formData);
        } catch (error: any) {
            console.log(error);
        }
    };
}